import React, { Component } from 'react'
import { connect } from 'react-redux'

import Modal from '../Shared/Modal'
import ModalHeader from '../Shared/ModalHeader'
import ModalButtonStrip from '../Shared/ModalButtonStrip'
import ModalBody from '../Shared/ModalBody'
import ModalFooter from '../Shared/ModalFooter'
import BoxButton from '../Layout/BoxButton'





import {
    showHideModalSummary,
    registerApprovalResult,
    updateInputs,
} from '../../actions/externosaprobaciones'
import { showHideModalDelete, downloadFile } from '../../actions/common'



class ModalSummary extends Component {
    handleCloseModal = () => {

        const modal = document.getElementById('modalSummary')
        modal.classList.remove('fadeIn')
        modal.classList.add('fadeOut')

        const modalDialog = document.querySelector(`#modalSummary .modal-dialog`)
        modalDialog.classList.remove('zoomIn')
        modalDialog.classList.add('zoomOut')

        setTimeout(() => this.props.showHideModalSummary(false), 300)
    }

    render() {

        const { modalSummary, enums } = this.props

        if (!modalSummary.get('show')) {
            return null
        }



        const adjunto = modalSummary.getIn(['data', 'adjuntos']).filter(a => a.get('documento_id') != null).last();
        const fileid = adjunto ? adjunto.get('id') : null;
        const filename = adjunto ? adjunto.get('nombre') : '';

        return(
            <Modal id="modalSummary" show={ true } ZIndex={ 2000 }>
                <ModalHeader title={ `Resumen del documento ${enums.documentos.tipos[modalSummary.getIn(['data', 'tipo'])].NOMBRE} ${modalSummary.getIn(['data', 'consecutivo'])}` } onClose={ e => this.handleCloseModal(e, "modalSummary") } />
                <ModalButtonStrip>


                    <BoxButton
                        name="check"
                        title="Aprobar"
                        onClick={ e => this.props.showHideModalDelete(true, `Al hacer click en el botón Ok, estará aprobando las condiciones del documento.`, () => { this.props.showHideModalDelete(false); this.handleCloseModal(); this.props.registerApprovalResult(modalSummary.getIn(['data', 'id']), 2)}) }
                    />

                    <BoxButton
                        name="ban"
                        title="Rechazar"
                        onClick={ e => this.props.showHideModalDelete(true, `Al hacer click en el botón Ok, estará rechazando el documento para ser corregido.`, () => { this.props.showHideModalDelete(false); this.handleCloseModal(); this.props.registerApprovalResult(modalSummary.getIn(['data', 'id']), 1)}) }
                    />


                </ModalButtonStrip>
                <ModalBody>
                    <div style={{ width: '800px' }}>
                        <div className="row">


                            <div className="col-md-4">
                                <div className="form-group">
                                    <label className="control-label">Documento</label>
                                    <input type="text" className="form-control input-sm" value={ enums.documentos.tipos[modalSummary.getIn(['data', 'tipo'])].NOMBRE } disabled />
                                </div>
                            </div>


                            <div className="col-md-2">
                                <div className="form-group">
                                    <label className="control-label">Número</label>
                                    <input type="text" className="form-control input-sm" value={ modalSummary.getIn(['data', 'consecutivo']) } disabled />
                                </div>
                            </div>

                                                        
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label className="control-label">Descargar</label>

                                    <label 
                                        className={`form-control input-sm label-upload-file label-upload-file-enabled`} 
                                        onClick={ adjunto ? () => this.props.downloadFile(fileid, filename) : () => null }  
                                    >
                                        <i className="fa fa-download"></i> { adjunto ? filename : '' }
                                    </label>


                                </div>
                            </div>


                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label className="control-label">Solicitante</label>
                                    <input type="text" className="form-control input-sm" value={ modalSummary.getIn(['data', 'solicitude', 'solicitante', 'fullname']) } disabled />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label className="control-label">Responsable compras</label>
                                    <input type="text" className="form-control input-sm" value={ modalSummary.getIn(['data', 'solicitude', 'responsable_compras', 'fullname']) } disabled />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="separator"></div>

                    <div className="row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <label className="control-label">Observaciones</label>
                                <textarea type="text" className="form-control input-sm" rows={4} value={ modalSummary.getIn(['data', 'observaciones']) } onChange = { (e) => this.props.updateInputs('modalSummary.data.observaciones', e.target.value) } />
                            </div>
                        </div>
                    </div>

                    <div className="separator"></div>


                </ModalBody>
                <ModalFooter>
                </ModalFooter>
            </Modal>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        modalSummary: state.externosaprobaciones.get('modalSummary'),
        enums: state.common.get('enums').toJS(),
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        showHideModalSummary: (state) => dispatch(showHideModalSummary(state)),
        showHideModalDelete: (open, message, action) => dispatch(showHideModalDelete(open, message, action)),
        registerApprovalResult: (id, result) => dispatch(registerApprovalResult(id, result)),
        downloadFile: (id, filename) => dispatch(downloadFile(id, filename)),
        updateInputs: (path, value) => dispatch(updateInputs(path, value))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalSummary)


// WEBPACK FOOTER //
// ./src/components/ExternosAprobaciones/ModalSummary.jsx